module.exports = "/static/assets/60402ee4ea5c76b0d47183b82dcc1b1b.png";